import type { CardDefinitionDto } from "../../types/CardDefinitionDto";
import type { CardDefinitionEntity } from "../../types/CardDefinitionEntity";

export const CardDefinitionEntityToDto = ({ ...rest }: Readonly<CardDefinitionEntity>): CardDefinitionDto => {
    return { ...rest };
};
